import React from 'react';
import LateralMenu from '../LateralMenu';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_citizen_app.png';
import collapsedLogo from '../../../assets/icon_sentinel_app.png';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faCar, faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { faBan } from '@fortawesome/pro-solid-svg-icons';

export default function CitizenLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {
    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            setOpen={setOpen}
            items={[{
                icon: faUser,
                text: translate('citizenManagement'),
                action: () => navigation.navigate('Citizen', { screen: 'CitizenManagement' }),
                selected: selectedMenu == 'citizen-management',
                omit: !authenticatedUser?.permissions.citizen_management
            }, {
                icon: faMagnifyingGlass,
                text: translate('plateSearch'),
                action: () => navigation.navigate('Citizen', { screen: 'CitizenLprSearch' }),
                selected: selectedMenu == 'citizen-lpr-search',
                omit: !authenticatedUser?.permissions.citizen_watch_lpr_events
            }, {
                icon: faCar,
                text: translate('citizenLprEvents'),
                action: () => navigation.navigate('Citizen', { screen: 'CitizenLprEvents' }),
                selected: selectedMenu == 'citizen-lpr-events',
                omit: !authenticatedUser?.permissions.citizen_watch_lpr_events
            }, {
                icon: faBan,
                text: translate('citizenBlockReasons'),
                action: () => navigation.navigate('Citizen', { screen: 'CitizenBlockReasons' }),
                selected: selectedMenu == 'citizen-block-reasons',
                omit: !authenticatedUser?.permissions.citizen_management_banishment
            }
            ]}
            open={open}
            authenticatedUser={authenticatedUser}
        />
    );
}
